import React from "react";
import { Stack } from "@mui/material";
import Content from "../constant/Content";
import { Login } from "../pages/login/LoginPage";
import Footer from "../layout/Footer";

const LoginContainer = () => {
  return (
    <Stack
      direction="column"
      component="main"
      sx={[
        {
          justifyContent: "space-between",
          height: { xs: "auto", md: "100vh" },
        },
        (theme) => ({
          backgroundImage:
            "radial-gradient(ellipse at 70% 51%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
          backgroundSize: "cover",
          ...theme.applyStyles("dark", {
            backgroundImage:
              "radial-gradient(at 70% 51%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
          }),
        }),
      ]}
    >
      <Stack
        direction={{ xs: "column-reverse", md: "row" }}
        sx={{
          justifyContent: "center",
          gap: { xs: 6, sm: 12 },
          p: 2,
          mb: "40px",
        }}
      >
        <Content />
        <Login />
      </Stack>
      <Footer />
    </Stack>
  );
};

export default LoginContainer;
